import React from "react";
import {
  Box,
  Card,
  Column,
  Columns,
  Heading,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { useProofPoints } from "../../context/ProofPointsContext";

export const PreAddressCards = () => {
  const { proofPoints = [] } = useProofPoints();

  return (
    <Box data-id="proofPoints">
      {/* Proof Points */}
      <Columns space="small" collapseBelow="lg" alignY="stretch">
        {proofPoints.map(({ iconURL, heading, text }) => (
          <Column key={`${heading}-${text}`} alignSelf="stretch">
            <Card height="full" borderRadius="medium">
              <Columns space="medium">
                <Column width="content">
                  <img
                    src={iconURL}
                    alt=""
                    aria-hidden="true"
                    style={{ height: "32px", width: "auto" }}
                  />
                </Column>
                <Column>
                  <Stack space="xxsmall">
                    <Heading variant="h4" weight="medium">
                      {heading}
                    </Heading>
                    <Text>{text}</Text>
                  </Stack>
                </Column>
              </Columns>
            </Card>
          </Column>
        ))}
      </Columns>
    </Box>
  );
};

export default PreAddressCards;
